import { createAsyncThunk } from "@reduxjs/toolkit";

import { getCentralizedResumeDatabase } from "@/modules/hrPortal/api/centralizedResumeDatabase.api";

import {
  CentralizedResume,
  CentralizedResumeDatabaseResponse,
  FetchCentralizedResumeDatabaseParams,
  Pagination,
  EMPTY_PAGINATION,
} from "../types";

// Backward-compatible re-exports: these two names used to be defined
// directly in this file. Re-exporting them (now sourced from the shared
// types folder) means any other file importing
// `{ CentralizedResume, CentralizedResumeDatabasePagination }` from this
// path keeps working unchanged.
export type { CentralizedResume, CentralizedResumeDatabaseResponse };
export type CentralizedResumeDatabasePagination = Pagination;

export const fetchCentralizedResumeDatabase = createAsyncThunk<
  CentralizedResumeDatabaseResponse,
  FetchCentralizedResumeDatabaseParams | undefined,
  {
    rejectValue: string;
  }
>("centralizedResumeDatabase/fetch", async (params = {}, { rejectWithValue }) => {
  try {
    const response = await getCentralizedResumeDatabase(
      params.page ?? 1,
      params.limit ?? 25,
      params.search ?? ""
    );

    return {
      resumes: response.data?.data ?? [],
      pagination:
        response.data?.pagination ??
        EMPTY_PAGINATION(params.page ?? 1, params.limit ?? 25),
    };
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data?.message ??
        error?.message ??
        "Failed to fetch centralized resume database."
    );
  }
});